<template>
    <div class="p-relative">
        <!-- Тулбар -->
        <div class="top-btns-bar">
           
            <div class="transparent-buttons">
                <v-btn 
                    v-if="allowReceptionScheduleAdd"                
                    small 
                    tile 
                    text
                    @click="onAddEvent()"
                >
                    <v-icon left>far fa-calendar-plus</v-icon>
                    {{$t("Добавить")}}
                </v-btn>
                <v-btn 
                    small 
                    tile 
                    text
                    @click="onUpdate"
                >
                    <v-icon left>far fa-sync-alt</v-icon>
                    {{$t("Обновить")}}
                </v-btn>
            </div>
            
            <!--Панель поиска  v-model="search"
            <SearchPanel
                :has-filter="false"
            />-->
        </div>

        <Calendar />
        <ReceptionScheduleDlg ref="ReceptionScheduleDlgRef" />
       
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import Calendar from '@/components/qala-qyzmet/reception-schedule/Calendar.vue';
import ReceptionScheduleDlg from '@/components/qala-qyzmet/dialogs/ReceptionScheduleDlg';

export default {
    name: "ReceptionCalendar",
    components: {
        Calendar,
        ReceptionScheduleDlg
    },
    computed: {
        allowReceptionScheduleAdd(){
            return this.$store.getters['global/auth/getUserInfo'].Permissions.includes("ReceptionScheduleAdd");
        }
    },
    methods: {
        ...mapActions('qalaQyzmet/receptionSchedule/calendar', 
        { 
            updateEvents: 'updateEvents' 
        }),
        onAddEvent() {
            console.log('onAddEvent clicked');
            this.$refs.ReceptionScheduleDlgRef.open();
        },
        onUpdate() {
            this.updateEvents();
        }
    }
}

</script>